import cloneDeep from "lodash/cloneDeep";
import { useCallback, useMemo } from "react";
export var useBannersData = function(eligibleBannersDisplayDataInPriorityOrder) {
    var replacedProductTilesCount = useMemo(function() {
        return eligibleBannersDisplayDataInPriorityOrder.reduce(function(prev, current) {
            if (current.useStandardPageSize) {
                return prev;
            }
            return prev + current.size;
        }, 0);
    }, [
        eligibleBannersDisplayDataInPriorityOrder
    ]);
    var sortedEligibleBannersDisplayData = useMemo(function() {
        return eligibleBannersDisplayDataInPriorityOrder.sort(function(displayDataA, displayDataB) {
            return displayDataA.row - displayDataB.row || displayDataA.column - displayDataB.column;
        });
    }, [
        eligibleBannersDisplayDataInPriorityOrder
    ]);
    var shouldRenderBanner = useCallback(function(banner, itemsPerRow, itemLength) {
        var numReplacedProductTiles = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        if (banner.renderAsModal) {
            return true;
        }
        var bannerPosition = itemsPerRow * banner.row - banner.size - numReplacedProductTiles;
        return itemLength >= bannerPosition;
    }, []);
    var displayableBanners = useCallback(function(itemsPerRow, itemLength) {
        var numReplacedProductTiles = 0;
        var banners = cloneDeep(sortedEligibleBannersDisplayData);
        return banners.filter(function(displayData) {
            if (displayData.row <= 0) {
                return false;
            }
            var shouldRender = shouldRenderBanner(displayData, itemsPerRow, itemLength, numReplacedProductTiles);
            if (shouldRender && !displayData.fullRowBanner) {
                numReplacedProductTiles += displayData.size;
            }
            return shouldRender;
        });
    }, [
        shouldRenderBanner,
        sortedEligibleBannersDisplayData
    ]);
    var displayableBannersWithAdjustedRow = useCallback(function(itemsPerRow, itemLength) {
        var banners = cloneDeep(displayableBanners(itemsPerRow, itemLength));
        var numFullRowBannersAbove = 0;
        banners.forEach(function(banner) {
            if (banner.rowNumberRelativeToProductRow) {
                banner.row += numFullRowBannersAbove;
            }
            if (banner.fullRowBanner) {
                numFullRowBannersAbove += 1;
                if (itemsPerRow === 5) {
                    banner.size = 5;
                }
            } else {
                // This will fix banner location when the itemPerRow increased to 5
                // in pages with different itemPerRow
                if (banner.column + banner.size - 1 !== itemsPerRow) {
                    banner.column = itemsPerRow - banner.size + 1;
                }
            }
        });
        return banners;
    }, [
        displayableBanners
    ]);
    return useMemo(function() {
        return {
            displayableBannersWithAdjustedRow: displayableBannersWithAdjustedRow,
            displayableBanners: displayableBanners,
            shouldRenderBanner: shouldRenderBanner,
            sortedEligibleBannersDisplayData: sortedEligibleBannersDisplayData,
            replacedProductTilesCount: replacedProductTilesCount
        };
    }, [
        displayableBannersWithAdjustedRow,
        displayableBanners,
        shouldRenderBanner,
        sortedEligibleBannersDisplayData,
        replacedProductTilesCount
    ]);
};
